import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CancelIcon from "@mui/icons-material/Cancel";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ReplayIcon from "@mui/icons-material/Replay";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";

interface NFseMenuProps {
	anchorEl: HTMLElement | null;
	onClose: () => void;
	row: any;
	onClickVisualizarNFSE: (row: any) => void;
	onClickCancelarNFSE: (row: any) => void;
	onClickGerarNFSE: (row: any) => void;
	onClickDownloadPDF: (row: any) => void;
	onClickRefreshStatus: (row: any) => void;
	onClickResendEmail: (row: any) => void;
}

export const NFMenu = ({
	anchorEl,
	onClose,
	row,
	onClickVisualizarNFSE,
	onClickCancelarNFSE,
	onClickGerarNFSE,
	onClickDownloadPDF,
	onClickRefreshStatus,
	onClickResendEmail,
}: NFseMenuProps) => {
	const open = Boolean(anchorEl);

	return (
		<Menu anchorEl={anchorEl} open={open} onClose={onClose}>
			<MenuItem
				onClick={() => {
					onClose();
					onClickVisualizarNFSE(row);
				}}
				disabled={!["authorized"].includes(row?.nfse_status) || !row?.nfse_id}
			>
				<ListItemIcon>
					<VisibilityIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>Visualizar NFSe</ListItemText>
			</MenuItem>

			<MenuItem
				onClick={() => {
					onClose();
					onClickGerarNFSE(row);
				}}
				disabled={!(row?.Installment_status === "paid" && !row?.Installment_nfseId)}
			>
				<ListItemIcon>
					<ReceiptIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>Gerar NFSe</ListItemText>
			</MenuItem>

			<MenuItem
				onClick={() => {
					onClose();
					onClickCancelarNFSE(row);
				}}
				disabled={!["authorized"].includes(row?.nfse_status)}
			>
				<ListItemIcon>
					<CancelIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>Cancelar NFSe</ListItemText>
			</MenuItem>

			<MenuItem
				onClick={() => {
					onClose();
					onClickDownloadPDF(row);
				}}
				disabled={!row?.nfse_id}
			>
				<ListItemIcon>
					<PictureAsPdfIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>Baixar PDF</ListItemText>
			</MenuItem>

			<MenuItem
				onClick={() => {
					onClose();
					onClickRefreshStatus(row);
				}}
				disabled={!row?.nfse_id}
			>
				<ListItemIcon>
					<ReplayIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>Atualizar Status</ListItemText>
			</MenuItem>

			<MenuItem
				onClick={() => {
					onClose();
					onClickResendEmail(row);
				}}
				disabled={true}
			>
				<ListItemIcon>
					<MarkEmailUnreadIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>Reenviar e-mail</ListItemText>
			</MenuItem>
		</Menu>
	);
};
